var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pi-block-content",class:{
    'pi-block-content-search': _vm.isSearch,
    large: _vm.size == 'large',
    'border-bottom': _vm.borderBottom || _vm.borderBottom === '',
  }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }